// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Localisation en % du volume de commande : reutilise EstimationBesoins.css (carrousel,
   sticky, scrollbar, skeleton, infobulle). Specifique ci-dessous. */

/* Suffixe % dans l'input (calque sur le suffixe € de l'estimation). */
.estimation-besoins-percent {
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6b7280;
}

/* Ligne d'en-tete d'une region : regroupe ses departements, agregat en lecture seule. */
.localisation-region-row td {
  background: #f3f4f6;
  font-weight: 700;
  color: #374151;
}
.localisation-region-row .col-lot {
  background: #f3f4f6;
}
.localisation-region-row .col-libelle {
  background: #f3f4f6;
}

/* Indentation du nom de departement sous sa region. */
.localisation-dep-libelle {
  padding-left: 1.6rem;
}

/* Cellule avec jauge : barre grise (gauche, proportionnelle au %) + saisie/valeur reduite (droite). */
.localisation-cell {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
}
.localisation-gauge {
  flex: 1 1 auto;
  min-width: 0.75rem;
  height: 0.45rem;
  background: #f3f4f6;
  border-radius: 999px;
  overflow: hidden;
}
.localisation-gauge-fill {
  display: block;
  height: 100%;
  background: #f97316;
  border-radius: 999px;
}
/* Input reduit (la jauge prend la largeur restante). Specificite renforcee pour primer
   sur la largeur de l'input partage. */
.localisation-input.estimation-besoins-input {
  width: 4.2rem;
  flex: 0 0 auto;
  text-align: right;
}
.localisation-readonly-val {
  flex: 0 0 auto;
  min-width: 2.2rem;
  text-align: right;
}
.localisation-cell-pct {
  flex: 0 0 auto;
  color: #6b7280;
}


/* Total d'une annee qui s'ecarte de 100 % : signale a l'acheteur. */
.localisation-total-off {
  color: #dc2626;
}

/* Ligne tampon (dernier departement) : cellule ajustee automatiquement = 100 - somme des
   autres. Lecture seule, presentee comme un agregat pour la distinguer d'une saisie. */
.col-annee.is-balancer {
  background: #f9fafb;
}
.localisation-balancer-value {
  color: #6b7280;
  font-weight: 600;
}
.localisation-hist-badge {
  display: inline-block;
  margin-left: 0.4rem;
  padding: 0.05rem 0.35rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 0.25rem;
  vertical-align: middle;
}

/* Capsule "Automatique" de la ligne tampon, sous le nom du departement (bloc -> nouvelle
   ligne, mais largeur ajustee au texte pour rester une pastille). */
.localisation-auto-label {
  display: block;
  width: fit-content;
  margin-left: 1.6rem;
  margin-top: 0.2rem;
  padding: 0.1rem 0.55rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 999px;
  line-height: 1.3;
}

/* Pastille d'etat de sauvegarde (entete sombre #595959) : point + texte court. */
.localisation-savestatus {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.15rem 0.6rem;
  font-size: 1.1rem;
  font-weight: 500;
  white-space: nowrap;
  color: #e5e7eb;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
}
.localisation-savestatus-dot {
  width: 0.5rem;
  height: 0.5rem;
  flex: none;
  border-radius: 50%;
  background: #9ca3af;
}
.localisation-savestatus--saved {
  color: #86efac;
}
.localisation-savestatus--saved .localisation-savestatus-dot {
  background: #86efac;
}
`, "",{"version":3,"sources":["webpack://./src/composants/LocalisationBesoins/LocalisationBesoins.css"],"names":[],"mappings":"AAAA;oEACoE;;AAEpE,sEAAsE;AACtE;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;;AAEA,wFAAwF;AACxF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,oBAAoB;AACtB;;AAEA,sGAAsG;AACtG;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;uCACuC;AACvC;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;;AAGA,oEAAoE;AACpE;EACE,cAAc;AAChB;;AAEA;uFACuF;AACvF;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;oEACoE;AACpE;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* Localisation en % du volume de commande : reutilise EstimationBesoins.css (carrousel,\n   sticky, scrollbar, skeleton, infobulle). Specifique ci-dessous. */\n\n/* Suffixe % dans l'input (calque sur le suffixe € de l'estimation). */\n.estimation-besoins-percent {\n  position: absolute;\n  right: 0.6rem;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #6b7280;\n}\n\n/* Ligne d'en-tete d'une region : regroupe ses departements, agregat en lecture seule. */\n.localisation-region-row td {\n  background: #f3f4f6;\n  font-weight: 700;\n  color: #374151;\n}\n.localisation-region-row .col-lot {\n  background: #f3f4f6;\n}\n.localisation-region-row .col-libelle {\n  background: #f3f4f6;\n}\n\n/* Indentation du nom de departement sous sa region. */\n.localisation-dep-libelle {\n  padding-left: 1.6rem;\n}\n\n/* Cellule avec jauge : barre grise (gauche, proportionnelle au %) + saisie/valeur reduite (droite). */\n.localisation-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n}\n.localisation-gauge {\n  flex: 1 1 auto;\n  min-width: 0.75rem;\n  height: 0.45rem;\n  background: #f3f4f6;\n  border-radius: 999px;\n  overflow: hidden;\n}\n.localisation-gauge-fill {\n  display: block;\n  height: 100%;\n  background: #f97316;\n  border-radius: 999px;\n}\n/* Input reduit (la jauge prend la largeur restante). Specificite renforcee pour primer\n   sur la largeur de l'input partage. */\n.localisation-input.estimation-besoins-input {\n  width: 4.2rem;\n  flex: 0 0 auto;\n  text-align: right;\n}\n.localisation-readonly-val {\n  flex: 0 0 auto;\n  min-width: 2.2rem;\n  text-align: right;\n}\n.localisation-cell-pct {\n  flex: 0 0 auto;\n  color: #6b7280;\n}\n\n\n/* Total d'une annee qui s'ecarte de 100 % : signale a l'acheteur. */\n.localisation-total-off {\n  color: #dc2626;\n}\n\n/* Ligne tampon (dernier departement) : cellule ajustee automatiquement = 100 - somme des\n   autres. Lecture seule, presentee comme un agregat pour la distinguer d'une saisie. */\n.col-annee.is-balancer {\n  background: #f9fafb;\n}\n.localisation-balancer-value {\n  color: #6b7280;\n  font-weight: 600;\n}\n.localisation-hist-badge {\n  display: inline-block;\n  margin-left: 0.4rem;\n  padding: 0.05rem 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #6b7280;\n  background: #f3f4f6;\n  border-radius: 0.25rem;\n  vertical-align: middle;\n}\n\n/* Capsule \"Automatique\" de la ligne tampon, sous le nom du departement (bloc -> nouvelle\n   ligne, mais largeur ajustee au texte pour rester une pastille). */\n.localisation-auto-label {\n  display: block;\n  width: fit-content;\n  margin-left: 1.6rem;\n  margin-top: 0.2rem;\n  padding: 0.1rem 0.55rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #6b7280;\n  background: #f3f4f6;\n  border-radius: 999px;\n  line-height: 1.3;\n}\n\n/* Pastille d'etat de sauvegarde (entete sombre #595959) : point + texte court. */\n.localisation-savestatus {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.15rem 0.6rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #e5e7eb;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 999px;\n}\n.localisation-savestatus-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  flex: none;\n  border-radius: 50%;\n  background: #9ca3af;\n}\n.localisation-savestatus--saved {\n  color: #86efac;\n}\n.localisation-savestatus--saved .localisation-savestatus-dot {\n  background: #86efac;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
